const DotsPattern: React.FC = () => (
  <svg
    viewBox="0 0 831 291"
    className="absolute inset-0 w-full h-full pointer-events-none"
    preserveAspectRatio="xMidYMid slice"
    aria-hidden="true"
    style={{ zIndex: 0 }}
  >
    <circle fill="#7EBEA5" cx="322.5" cy="47.5" r="4.5" />
    <circle fill="#7365FF" cx="268" cy="12" r="6" />
    <circle fillOpacity="0.6" fill="#26295E" cx="649" cy="58" r="6" />
    <circle fill="#7B9DED" cx="380.5" cy="7.5" r="3.5" />
    <circle fill="#7365FF" cx="480.5" cy="34.5" r="3.5" />
    <circle fillOpacity="0.6" fill="#7B9DED" cx="72.5" cy="24.5" r="3.5" />
    <circle fillOpacity="0.6" fill="#7B9DED" cx="124.5" cy="287.5" r="3.5" />
    <circle fillOpacity="0.6" fill="#7365FF" cx="3.5" cy="107.5" r="3.5" />
    <circle fillOpacity="0.6" fill="#7B9DED" cx="32.5" cy="202.5" r="3.5" />
    <circle
      fill="#8DE2B0"
      fillOpacity="0.6"
      cx="825.714364"
      cy="71.3197731"
      r="4.5"
    />
    <circle fillOpacity="0.6" fill="#7365FF" cx="672.5" cy="107.5" r="3.5" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="599.5" cy="3.5" r="3.5" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="726.5" cy="21.5" r="3.5" />
    <circle fillOpacity="0.4" fill="#7EBEA5" cx="496" cy="2" r="2" />
    <circle fillOpacity="0.4" fill="#7B9DED" cx="544" cy="64" r="2" />
    <circle fill="#7B9DED" cx="316" cy="224" r="2" />
    <circle fillOpacity="0.6" fill="#26295E" cx="72" cy="260" r="2" />
    <circle fillOpacity="0.4" fill="#7EBEA5" cx="590" cy="125" r="2" />
    <circle fillOpacity="0.4" fill="#7365FF" cx="561" cy="188" r="2" />
    <circle
      fillOpacity="0.6"
      fill="#7B9DED"
      cx="797.932679"
      cy="283.000815"
      r="3"
    />
    <circle fill="#7365FF" cx="734.5" cy="86.5" r="4.5" />
    <circle fill="#7365FF" cx="310.5" cy="283.5" r="4.5" />
    <circle
      fillOpacity="0.6"
      fill="#7EBEA5"
      cx="790.257953"
      cy="196.198129"
      r="5.5"
    />
    <circle fill="#7EBEA5" cx="58.5" cy="112.5" r="5.5" />
  </svg>
);

export default DotsPattern;
